export default [
    {
        path: '/eventItems',
        name: 'eventItems',
        component: () => import ('./pages/EventItemRegister')
    },
]